(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        if (initialState === undefined) this.board = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        else this.board = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== "playing" && this.status !== "win") return;
                var boardBefore = JSON.stringify(this.board);
                for(var i = 0; i < this.board.length; i++)this.board[i] = this.slideAndMerge(this.board[i]);
                this.lostAndChangesOnAfterMove(boardBefore);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.status !== "playing" && this.status !== "win") return;
                var boardBefore = JSON.stringify(this.board);
                for(var i = 0; i < this.board.length; i++){
                    var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.board[i]).reverse();
                    var backToRight = this.slideAndMerge(reversedRow).reverse();
                    this.board[i] = backToRight;
                }
                this.lostAndChangesOnAfterMove(boardBefore);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.status !== "playing" && this.status !== "win") return;
                var boardBefore = JSON.stringify(this.board);
                for(var i = 0; i < this.board.length; i++){
                    var column = [];
                    for(var j = 0; j < this.board.length; j++)column.push(this.board[j][i]);
                    var processed = this.slideAndMerge(column);
                    for(var j1 = 0; j1 < this.board.length; j1++)this.board[j1][i] = processed[j1];
                }
                this.lostAndChangesOnAfterMove(boardBefore);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.status !== "playing" && this.status !== "win") return;
                var boardBefore = JSON.stringify(this.board);
                for(var i = 0; i < this.board.length; i++){
                    var column = [];
                    for(var j = 0; j < this.board.length; j++)column.push(this.board[j][i]);
                    var processed = this.slideAndMerge(column.reverse()).reverse();
                    for(var j1 = 0; j1 < this.board.length; j1++)this.board[j1][i] = processed[j1];
                }
                this.lostAndChangesOnAfterMove(boardBefore);
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                if (this.getEmptyCells().length === 16) {
                    this.addRandomBlock();
                    this.addRandomBlock();
                }
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.clearTheBoard();
                this.score = 0;
                this.start();
            }
        },
        {
            // Add your own methods here
            key: "addRandomBlock",
            value: function addRandomBlock() {
                var rowsAndColumns = this.getEmptyCells();
                if (rowsAndColumns.length >= 1) {
                    var randomIndex = Math.floor(Math.random() * rowsAndColumns.length);
                    var ratio = Math.random() * 100;
                    var el = rowsAndColumns[randomIndex];
                    if (ratio > 90) this.board[el[0]][el[1]] = 4;
                    else this.board[el[0]][el[1]] = 2;
                }
            }
        },
        {
            key: "getEmptyCells",
            value: function getEmptyCells() {
                var rowsAndColumns = [];
                for(var i = 0; i < this.board.length; i++){
                    for(var j = 0; j < this.board[0].length; j++)if (this.board[i][j] === 0) rowsAndColumns.push([
                        i,
                        j
                    ]);
                }
                return rowsAndColumns;
            }
        },
        {
            key: "clearTheBoard",
            value: function clearTheBoard() {
                for(var i = 0; i < this.board.length; i++)for(var j = 0; j < this.board[0].length; j++)this.board[i][j] = 0;
            }
        },
        {
            key: "slideAndMerge",
            value: function slideAndMerge(row) {
                var filtered = row.filter(function(el) {
                    return el !== 0;
                });
                var merged = [];
                for(var j = 0; j < filtered.length; j++){
                    var cur = filtered[j];
                    var next = filtered[j + 1];
                    if (cur === next) {
                        merged.push(cur + next);
                        this.score += cur + next;
                        if (cur + next === 2048) this.status = "win";
                        j++;
                    } else merged.push(cur);
                }
                while(merged.length < 4)merged.push(0);
                return merged;
            }
        },
        {
            key: "checkChanges",
            value: function checkChanges(boardBefore) {
                var boardAfter = JSON.stringify(this.board);
                if (boardBefore !== boardAfter) return true;
                return false;
            }
        },
        {
            key: "isGameLost",
            value: function isGameLost() {
                if (this.getEmptyCells().length > 0) return false;
                for(var i = 0; i < this.board.length; i++)for(var j = 0; j < this.board[0].length - 1; j++){
                    if (this.board[i][j] === this.board[i][j + 1]) return false;
                    if (this.board[j][i] === this.board[j + 1][i]) return false;
                }
                return true;
            }
        },
        {
            key: "lostAndChangesOnAfterMove",
            value: function lostAndChangesOnAfterMove(boardBefore) {
                if (this.checkChanges(boardBefore)) {
                    this.addRandomBlock();
                    if (this.status !== "win" && this.isGameLost()) this.status = "lose";
                }
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
// Write your code here
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$button.textContent === "Start") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$changeBoard();
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$changeBoard();
    }
});
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$button.textContent === "Start") {
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$button.classList.replace("start", "restart");
    }
    if (e.key === "ArrowLeft") $197cd56b15c33885$var$game.moveLeft();
    if (e.key === "ArrowRight") $197cd56b15c33885$var$game.moveRight();
    if (e.key === "ArrowUp") $197cd56b15c33885$var$game.moveUp();
    if (e.key === "ArrowDown") $197cd56b15c33885$var$game.moveDown();
    $197cd56b15c33885$var$changeBoard();
});
function $197cd56b15c33885$var$changeBoard() {
    var _loop = function(i) {
        var _loop = function(j) {
            var value = board[i][j];
            var index = i * board[0].length + j;
            allCells[index].classList.forEach(function(className) {
                if (className.startsWith("field-cell--")) allCells[index].classList.remove(className);
            });
            if (value === 0) allCells[index].textContent = "";
            if (value !== 0) {
                allCells[index].textContent = value;
                allCells[index].classList.add("field-cell--" + value);
            }
        };
        for(var j = 0; j < board[0].length; j++)_loop(j);
    };
    var allCells = document.querySelectorAll(".field-cell");
    var board = $197cd56b15c33885$var$game.getState();
    for(var i = 0; i < board.length; i++)_loop(i);
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    else {
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
    }
}

})();
//# sourceMappingURL=index.97bcd84a.js.map
